import { render } from "./create_kids_product.vue?vue&type=template&id=53b321c3&scoped=true"
import script from "./create_kids_product.vue?vue&type=script&lang=js"
export * from "./create_kids_product.vue?vue&type=script&lang=js"

import "./create_kids_product.vue?vue&type=style&index=0&id=53b321c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b321c3"]])

export default __exports__